export default "__VITE_ASSET__3fqLXbia__"